var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"161272977e7c89f6771f7c84041f514870dc2650"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["engine-frontend@apollograph"]={id:"161272977e7c89f6771f7c84041f514870dc2650"};
      